import {
  Directive,
  ElementRef,
  EmbeddedViewRef,
  EventEmitter,
  Host,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { MatTable } from '@angular/material/table';

@Directive({
  selector: '[2appTableRowMovement]',
})
export class TableRowMovementDirective implements OnInit, OnDestroy {
  @Output() onEnterEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() onEscape: EventEmitter<void> = new EventEmitter<void>();

  pageRef: ElementRef;
  @Input() selectedIndex: BehaviorSubject<number>;
  @Input() dataSource$: Observable<any[]>;
  @Input() disabled$: Observable<boolean>;

  private subscriptions = new Subscription();
  private data: any[];
  private disabled: boolean;

  constructor(
    el: ElementRef,
    private renderer: Renderer2,
    @Host() private table: MatTable<any>
  ) {
    this.pageRef = el;
  }

  ngOnInit(): void {
    if (this.dataSource$) {
      this.subscriptions.add(
        this.dataSource$.subscribe((data) => {
          this.data = data;
          // console.log('this.data', this.data);
        })
      );
    }
    if (this.disabled$) {
      this.subscriptions.add(
        this.disabled$.subscribe((value) => {
          this.disabled = value;
        })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * Handle arrow down event.
   *
   * @param event
   */
  @HostListener('document:keydown.arrowdown', ['$event']) onArrowDown(
    event: KeyboardEvent
  ) {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }

    event.preventDefault();

    if (this.data.length > this.selectedIndex.getValue() + 1) {
      this.selectedIndex.next(this.selectedIndex.getValue() + 1);
      this.scrollToElement();
    }
  }

  /**
   * Handle arrow up event.
   *
   * @param event
   */
  @HostListener('document:keydown.arrowup', ['$event']) onArrowUp(
    event: KeyboardEvent
  ) {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }

    event.preventDefault();

    if (this.selectedIndex.getValue() > 0) {
      this.selectedIndex.next(this.selectedIndex.getValue() - 1);
      this.scrollToElement();
    }
  }

  /**
   * Handle enter event.
   *
   * @param event
   */
  @HostListener('document:keydown.enter', ['$event']) onEnter() {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }
    this.onEnterEvent.emit();
  }

  /**
   * Handle escape Key press. Cancel order selection.
   *
   * @param event
   */
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }
    this.onEscape.emit();
  }

  private scrollToElement() {
    let waiting = false;
    const index = this.selectedIndex.getValue();

    // eslint-disable-next-line no-underscore-dangle
    if (index >= 0 && index < this.table._rowOutlet.viewContainer.length) {
      // eslint-disable-next-line no-underscore-dangle
      const viewRef = this.table._rowOutlet.viewContainer.get(index);
      const element = (viewRef as EmbeddedViewRef<any>).rootNodes[0];

      this.renderer.setStyle(element, 'pointerEvents', 'none');
      element.scrollIntoView(false);

      if (!waiting) {
        setTimeout(() => {
          this.renderer.setStyle(element, 'pointerEvents', 'auto');
          waiting = false;
        }, 500);
        waiting = true;
      }
    }
  }
}
